// extracted by mini-css-extract-plugin
module.exports = {"main":"Dev_main__9IIXc","heading":"Dev_heading__G2J4h","arrow":"Dev_arrow__2v_g7","projects":"Dev_projects__2HNol","link":"Dev_link__2OhuB"};